const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

const FileSizeFormatter = (bytes, data, propName, props = {}) => {
  const { fractionDigits = 1 } = props;
  if (bytes === 0) {
    return '0 KB';
  }
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  // const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${parseFloat((bytes / (1024 ** i)).toFixed(fractionDigits))} ${sizes[i]}`;
};

export default FileSizeFormatter;
